import {Typography} from '@/components/Typography';
import {getCompareAvgLevel} from '@/map/utils';
import {palette} from '@/styles';

interface IProps {
  ctprvn?: string;
  total?: number;
  average?: number;
}

export const CompareAverage = ({ctprvn, total, average}: IProps) => {
  if (!total || !average) {
    return null;
  }

  const level = getCompareAvgLevel(total, average);

  return (
    <Typography variant="medium12" color={palette.gray600}>
      {level === 0
        ? `${ctprvn || '시/도'} 평균과 비슷해요`
        : `
        ${ctprvn || '시/도'} 평균 대비 ${Math.abs(level) === 2 ? '매우 ' : ''}
        ${level > 0 ? '높아요' : '낮아요'}
      `}
    </Typography>
  );
};
